import { ContentCard } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";

import Account from "byzantine/src/Account";
import { modules } from "byzantine";
import AlertsHeading from "../AlertsHeading";
import AlertsFormWrapper, { AlertsWrapper } from "../AlertsFormWrapper";
import AlertForm from "../AlertForm";

import styles from "./AlertPage.module.scss";

type AlertPageType = "balance-alerts" | "spending-alerts";

interface AlertPageProps {
  accounts: Account[];
  pageKey: AlertPageType;
}

const AlertPage = ({ pageKey, accounts }: AlertPageProps) => {
  const { l10n } = useLocalization();
  const alerts = modules.alerts.useAlertSections(accounts);
  const pageAlerts = alerts.find((section) => section.sectionKey === pageKey);

  if (!pageAlerts) {
    return null;
  }

  return (
    <div className={styles.container}>
      <AlertsHeading
        heading={l10n.getString(
          `enhanced-alert-section-title-${pageKey}`,
          {},
          "Alerts"
        )}
      />
      <ContentCard kind="bordered">
        <AlertsWrapper>
          {pageAlerts.items.map(({ key }) => (
            <AlertsFormWrapper key={key}>
              <AlertForm alertKey={key} />
            </AlertsFormWrapper>
          ))}
        </AlertsWrapper>
      </ContentCard>
    </div>
  );
};

export default AlertPage;
